/**
 * @fileoverview DELETE handler for the "/comments/:target/threads/:thread_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { mutationCacheKeys } from "./constants";
import type {
  AppendAppGroupToUrl,
  DeleteCommentThreadProps,
  EmptyResult as DeleteCommentThreadResult,
} from "./types";

export const deleteCommentThread = reactQueryMutationAdapter(
  mutationCacheKeys,
  (props: AppendAppGroupToUrl<DeleteCommentThreadProps>): Promise<DeleteCommentThreadResult> => {
    return fetch(`/comments/${props.target}/threads/${props.threadId}?app_group_id=${props.appGroupId}`, "DELETE");
  }
);
